module.exports = __webpack_public_path__ + "img/technologyImg5.92355804.png";